<ng-container *ngIf="config.icon">
  <ix-icon class="icon" [name]="config.icon" [style.color]="iconColor"></ix-icon>
</ng-container>

<div class="message">{{ config.message }}</div>
